import React, { useState } from 'react';
import api from '../../services/api';
import AuthLayout, { AuthLink } from './AuthLayout';
import { Button, Input, Alert } from '../../components/ui';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setIsButtonDisabled(true);
    setErrorMessage('');
    setSuccessMessage('');

    try {
      const response = await api.post('/user/forgot-password', { email });

      if (response.status === 200) {
        setSuccessMessage('Check your email for the reset link.');
      }
    } catch (error) {
      setErrorMessage(error.response?.data?.message || 'Something went wrong. Please try again.');
      setIsButtonDisabled(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="We'll email you a link to set a new one."
      footer={
        <>
          Remember your password? <AuthLink to="/login">Sign in</AuthLink>
        </>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-4" noValidate>
        {successMessage && (
          <Alert variant="success" title="Email sent">
            {successMessage}
          </Alert>
        )}
        {errorMessage && <Alert variant="error">{errorMessage}</Alert>}

        <Input
          label="Email"
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={isSubmitting}
          autoComplete="email"
          hint="Use the address associated with your account."
        />

        <Button type="submit" size="lg" fullWidth loading={isSubmitting} disabled={isButtonDisabled}>
          {isSubmitting ? 'Sending…' : 'Send reset link'}
        </Button>
      </form>
    </AuthLayout>
  );
}

export default ForgotPassword;
